import React, {
  useEffect,
  useState,
  Fragment,
  memo,
  useRef,
  useContext
} from 'react';
import CommonBtn from '../../../containers/LeadProfile/CommonBtn/CommonBtn';
import nextCmDoc from '../../../images/icons/nextCmDoc.svg';
import {
  getInPrincipleDocs,
  genericVerifyDoc,
  genericRejectDoc
} from '../../../common/constants/api';
import { ApplicantHeading } from '../../../components/CompanyDetailsCMView/CompanyDetailsCMView';
import { getApplicantionInfo } from '../../../common/utils/applicantionInfo';
import pdf from '../../../images/icons/CmDashIcons/pdfXl.svg';
import PopUp from '../../../common/components/PopUp/PopUp';
import CircularLoading from '../../../common/components/CircularLoading/CircularLoading';
import ShowDoc from '../../../containers/CMDashboard/ShowDoc';
import CommonComment from '../../../components/CommonComment/CommonComment';
import withErrorHandler from '../../..//hoc/withErrorHandler/withErrorHandler';
import { useForceRerender } from '../../../hooks/useForceRender';
import { ReadOnly } from '../../../containers/CMDashboard/CMDetailView';

const CMKycDocViewer = ({ docType, title }) => {
  const [leadId, setLeadId] = useState(getApplicantionInfo().leadId);
  const [docObj, setDocObj] = useState([]);
  const [docArr, setDocArr] = useState([]);
  const [verifyArr, setVerifyArr] = useState([]);
  const [tempVar, setTempVar] = useState(false);
  const [isGetOver, setIsGetOver] = useState(false);
  const [case403, setCase403] = useState(false);
  const [callDocApi, setCallDocApi] = useState(false);
  const [show, setShow] = useState(false);
  const [docNotVerified, setDocNotVerified] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isFullImage, setFullImage] = useState(false);
  const [file, setFile] = useState(false);
  const [fileTitle, setFileTitle] = useState('');
  const [updateTrigger, setUpdateTrigger] = useState(false);
  const [error, setError] = useState('');
  const [popShow, setPopShow] = useState(false);
  const myRefs = useRef([]);
  const isReadOnly = useContext(ReadOnly);
  const forceRerender = useForceRerender();

  useEffect(() => {
    (async () => {
      await getInPrincipleDocs(leadId, docType)
        .then(async res => {
          await setDocObj(res);

          setTempVar(!tempVar);
          let tempDoc = [];
          let tempVerifyArr = [];
          res.map(async (el, i) => {
            if (i === 0) {
              let mainApplicantDoc = [];
              let mainVerifyArr = [];
              el.applicantDocs.map(el => {
                mainApplicantDoc.push(el.link.url);
                mainVerifyArr.push(el.verified);
              });
              tempDoc.push(mainApplicantDoc);
              tempVerifyArr.push(mainVerifyArr);
            }
            if (i > 0) {
              window['verifyDoc' + i] = [];
              window['co_applicant' + i] = [];
              el.applicantDocs.map(el => {
                window['co_applicant' + i].push(el.link.url);
                window['verifyDoc' + i].push(el.verified);
              });
              tempDoc.splice(i, 0, window['co_applicant' + i]);
              tempVerifyArr.splice(i, 0, window['verifyDoc' + i]);
            }
          });
          setDocArr(tempDoc);
          setVerifyArr(tempVerifyArr);
          setIsGetOver(true);
        })
        .catch(err => {
          setIsGetOver(true);
          setError(
            err?.response?.data?.message ||
              'something went wrong! Please try again..'
          );
          if (err?.response?.status === 403) {
            setCase403(true);
            setError(
              err?.response?.data?.message ||
                'Your un-authorised to view this doc'
            );
          }
          setShow(true);
        });
    })(setTempVar(!tempVar));
    return () => {
      setCase403(false);
      setIsGetOver(false);
    };
  }, [docType, callDocApi, updateTrigger]);

  useEffect(() => {
    if (docObj.length > 0)
      docObj.map((el, i) => {
        window['imgIndex' + i] = 0;
        setTempVar(!tempVar);
      });
  }, [docObj]);

  const docTypeSetter = docType => {
    if (docType === 'application/pdf') {
      setIsError(true);
      setFullImage(true);
    } else {
      setFullImage(true);
    }
  };

  const docRenderer = (i, action) => {
    window['imgIndex' + i] = window['imgIndex' + i] + action;
    myRefs.current[i].src = docArr[i]?.[window['imgIndex' + i]];
    setTempVar(!tempVar);
  };
  const pdfSetter = i => {
    myRefs.current[i]?.parentNode.classList.add(
      'bg-grey-1007',
      'border',
      'border-grey-1006',
      'w-full',
      'h-full',
      'border-dashed'
    );
  };
  const pdfStyleRemoval = i => {
    myRefs.current[i]?.parentNode.classList.remove(
      'bg-grey-1007',
      'border',
      'border-grey-1006',
      'w-full',
      'h-full',
      'border-dashed'
    );
  };
  const verificationHandler = docId => {
    genericVerifyDoc(leadId, docId)
      .then(res => {
        setCallDocApi(!callDocApi);
      })
      .catch(err => {});
  };
  const rejectHandler = docId => {
    genericRejectDoc(leadId, docId, 'Incorrect Document')
      .then(res => {
        setCallDocApi(!callDocApi);
      })
      .catch(err => {});
  };

  const propsRenderer = () => {
    let props = {};
    if (case403) {
      props.type = 'fail';
      props.text = error;
      props.dontClose = true;
      props.goto = true;
      return props;
    }
    if (error) {
      props.type = 'fail';
      props.text = error;
      return props;
    }
  };

  if (isGetOver || show) {
    if (docObj?.length > 0 && docArr[0]?.length > 0) {
      return (
        <Fragment>
          {show && <PopUp {...propsRenderer()} setShow={setShow} show={show} />}

          {docObj.map((el, i) => {
            if (el.applicantDocs.length > 0)
              return (
                <div key={i} className="w-full block bg-white mt-5">
                  <div
                    className="flex flex-col mx-auto md:mr-auto md:ml-0 mb-2"
                    style={{ width: 'fit-content' }}
                  >
                    <div className="mb-3">
                      {i === 0 ? (
                        <ApplicantHeading heading="Main Applicant" />
                      ) : (
                        <ApplicantHeading heading={`Co-applicant ${i}`} />
                      )}

                      {docType === 'address-proof' && (
                        <div className="mt-2 capitalize">
                          {el.type.replace(/_/g, ' ')}
                        </div>
                      )}
                    </div>
                    {verifyArr[i][window['imgIndex' + i]] ? (
                      <div className="flex items-center">
                        <span className="text-green-paleGreen bg-green-thinGreen font-roboto font-normal px-2 text-xs  items-center rounded ">
                          Verified
                        </span>
                        {!isReadOnly ? (
                          <span
                            onClick={() => {
                              let tempVerifyArr = verifyArr.slice();
                              tempVerifyArr[i][window['imgIndex' + i]] = null;
                              setVerifyArr(tempVerifyArr);
                            }}
                            className="text-orange-1100 font-roboto font-norma ml-1 items-center text-xs cursor-pointer"
                          >
                            Undo
                          </span>
                        ) : null}
                      </div>
                    ) : null}
                    {verifyArr[i][window['imgIndex' + i]] === false &&
                    verifyArr[i][window['imgIndex' + i]] !== null ? (
                      <div className="flex items-center">
                        <span className="text-red-200 bg-red-600 font-roboto font-normal px-2 text-xs  items-center rounded ">
                          Not Verified
                        </span>
                        {!isReadOnly ? (
                          <span
                            onClick={() => {
                              let tempVerifyArr = verifyArr.slice();
                              tempVerifyArr[i][window['imgIndex' + i]] = null;
                              setVerifyArr(tempVerifyArr);
                            }}
                            className="text-orange-1100 font-roboto font-norma ml-1 items-center text-xs cursor-pointer"
                          >
                            Undo
                          </span>
                        ) : null}
                      </div>
                    ) : null}
                  </div>

                  <div className="w-full xmd:flex xmd:flex-col xxl:flex-row  block xmd:flex-wrap ">
                    <div
                      className={`shadow-md  rounded-md border border-grey-1009 p-5 lg:w-144 lg:h-81 w-full mr-6`}
                      onClick={() => {
                        setFileTitle(
                          `${title}${
                            el.applicantDocs[window['imgIndex' + i]]?.link?.tag
                              ? ` - ${
                                  el.applicantDocs[window['imgIndex' + i]]?.link
                                    ?.tag
                                }`
                              : ''
                          }`
                        );
                        setFile(docArr[i]?.[window['imgIndex' + i]]),
                          docTypeSetter(
                            el.applicantDocs[window['imgIndex' + i]]?.link
                              ?.docType
                          );
                      }}
                    >
                      <img
                        className="max-w-full max-h-full block mx-auto object-cover"
                        ref={el => (myRefs.current[i] = el)}
                        onLoad={() => {
                          pdfStyleRemoval(i);
                        }}
                        src={docArr[i]?.[window['imgIndex' + i]]}
                        onError={e => {
                          e.target.onError = null;
                          e.target.src = pdf;
                          setIsError(true);
                          e.target.className =
                            ' max-w-full max-h-full block mx-auto object-cover';
                          pdfSetter(i);
                        }}
                      />
                    </div>
                    {/* slider */}
                    <div className="flex flex-row xxl:flex-col w-full  xxl:w-64 justify-between xxl:justify-between mt-3 xxl:mt-0 xxl:py-4">
                      {docArr[i]?.length > 1 && (
                        <Fragment>
                          <div className="flex flex-col order-2 xxl:order-none mr-2 mt-2 xxl:mt-0  ml-auto xxl:ml-0">
                            <div className=" flex flex-row justify-between w-20   ml-auto mr-3 ">
                              <div
                                onClick={() => {
                                  if (window['imgIndex' + i] !== 0)
                                    docRenderer(i, -1);
                                }}
                                className={
                                  (window['imgIndex' + i] === 0
                                    ? 'opacity-25'
                                    : '') +
                                  ' w-9 h-9 border border-tealCol-100 text-tealCol-100 rounded '
                                }
                              >
                                <img
                                  className="transform -rotate-90 mt-2.5 mx-auto"
                                  src={nextCmDoc}
                                  alt="<"
                                />
                              </div>
                              <div
                                onClick={() => {
                                  if (
                                    window['imgIndex' + i] !==
                                    docArr[i]?.length - 1
                                  )
                                    docRenderer(i, +1);
                                }}
                                className={
                                  (window['imgIndex' + i] ===
                                  docArr[i]?.length - 1
                                    ? 'opacity-25'
                                    : '') +
                                  ' w-9 h-9 border border-tealCol-100 text-tealCol-100 rounded'
                                }
                              >
                                <img
                                  className="transform rotate-90 mt-2.5 mx-auto"
                                  src={nextCmDoc}
                                  alt=">"
                                />
                              </div>
                            </div>
                            <p className="text-base text-black-1003 self-start ml-auto mr-3 mt-2">
                              {window['imgIndex' + i] +
                                1 +
                                '/' +
                                docArr[i]?.length}
                            </p>
                          </div>
                        </Fragment>
                      )}
                      {verifyArr[i][window['imgIndex' + i]] === null &&
                        !isReadOnly && (
                          <div
                            className={` flex  xxl:ml-0 xxl:mt-28  order-1 xxl:order-none mx-auto`}
                            style={{ width: 'fit-content' }}
                          >
                            <CommonBtn
                              value="Not Verified"
                              stylesBtn={{
                                backgroundColor: 'white',
                                color: '#FD4F60',
                                padding: '14px',
                                borderColor: '#FD4F60',
                                border: '1px solid',
                                width: '7rem',
                                textAlign: 'center',
                                display: 'block'
                              }}
                              onClick={() => {
                                rejectHandler(
                                  el.applicantDocs[window['imgIndex' + i]]?.link
                                    .docId
                                );
                              }}
                            />
                            <CommonBtn
                              value="Verified"
                              stylesBtn={{
                                backgroundColor: 'white',
                                color: '#00ACB8',
                                borderColor: '#00ACB8',
                                padding: '14px',
                                border: '1px solid',
                                width: '7rem',
                                textAlign: 'center',
                                display: 'block'
                              }}
                              onClick={() => {
                                verificationHandler(
                                  el.applicantDocs[window['imgIndex' + i]]?.link
                                    .docId
                                );
                              }}
                            />
                          </div>
                        )}
                    </div>
                  </div>

                  {isFullImage && (
                    <ShowDoc
                      fileTitle={fileTitle}
                      setShow={setFullImage}
                      show={isFullImage}
                      setIsError={setIsError}
                      file={file}
                      isError={isError}
                    />
                  )}
                  <div
                    className="flex self-end "
                    style={{ width: 'fit-content', marginLeft: '27.5rem' }}
                  >
                    {!isReadOnly ? (
                      <CommonComment
                        passAnyDocId={
                          el.applicantDocs[window['imgIndex' + i]]?.link?.docId
                        }
                      />
                    ) : null}
                  </div>
                </div>
              );
            return null;
          })}
        </Fragment>
      );
    } else {
      return (
        <div
          className="absolute inset-x-3/10 mt-20 text-black-1003 text-base font-medium"
          style={{ width: 'fit-content' }}
        >
          No Documents Available. .
        </div>
      );
    }
  } else {
    return (
      <div className="w-full flex content-center items-center relative -ml-10 ">
        <div className="absolute inset-1/2 mt-40 ">
          <CircularLoading />
        </div>
      </div>
    );
  }
};

export default memo(withErrorHandler(CMKycDocViewer));
